import Swiper, { EffectFade } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  // mobile menu
  const masthead = document.querySelector('.masthead');

  document.querySelectorAll('.mobile-menu-toggle').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      masthead.classList.toggle('toggled');
    });
  });

  if (document.body.classList.contains('home')) {
    document.querySelectorAll('.home-sets--main-slider').forEach((el) => {
      new Swiper(el, {
        centeredSlides: true,
        slidesPerView: 1.7,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
          992: {
            slidesPerView: 4,
          },
        },
      });
    });

    // delivery calc map

    // eslint-disable-next-line no-undef
    const center = new google.maps.LatLng(52.22413, 20.8965534);

    const mapOptions = {
      zoom: 9,
      center: center,
      disableDefaultUI: true,
    };

    const mapElement = document.getElementById('gmap');
    // eslint-disable-next-line no-undef
    const map = new google.maps.Map(mapElement, mapOptions);

    // eslint-disable-next-line no-undef
    // const image = lotus.gMapsMarkerIcon

    // eslint-disable-next-line no-undef
    new google.maps.Marker({
      // eslint-disable-next-line no-undef
      position: center,
      map: map,
      // title: 'Lotus',
      // icon: image,
    });

    const radius = {
      strokeColor: '#7a1e88',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#7a1e88',
      fillOpacity: 0.35,
      map: map,
      center: center,
      radius: 8000,
    };

    // eslint-disable-next-line no-undef
    const circle = new google.maps.Circle(radius);

    // delivery calc
    const radii = document.getElementsByName('calcRadius');
    const finalDeliveryCostElement = document.getElementById('finalDeliveryCost');
    const amountElement = document.getElementById('amount');

    radii.forEach((el) => {
      el.addEventListener('change', () => {
        calculateFinalDeliveryPrice();

        circle.setRadius(el.value * 1000);
      });
    });

    const amount = document.getElementsByName('calcAmount')[0];

    const getSelectedAmount = () => {
      return amount.value;
    };

    amount.addEventListener('input', () => {
      calculateFinalDeliveryPrice();

      amountElement.textContent = getSelectedAmount();
    });

    const getDeliveryCost = () => {
      return parseInt(Array.from(radii).find((el) => el.checked).dataset.deliveryCost);
    };

    const getThreshold = () => {
      return parseInt(Array.from(radii).find((el) => el.checked).dataset.threshold);
    };

    const getCurrentData = () => {
      const selectedAmount = getSelectedAmount();
      const deliveryCost = getDeliveryCost();
      const threshold = getThreshold();

      return {
        selectedAmount: selectedAmount,
        deliveryCost: deliveryCost,
        threshold: threshold,
      };
    };

    const calculateFinalDeliveryPrice = () => {
      const { selectedAmount, deliveryCost, threshold } = getCurrentData();

      if (selectedAmount > threshold) {
        finalDeliveryCostElement.textContent = 'Za darmo!';
      } else {
        finalDeliveryCostElement.textContent = `${deliveryCost} PLN`;
      }
    };
  } else if (document.body.classList.contains('page-template-template-edu')) {
    const switchToggle = document.querySelector('.page-edu--header-switch input');

    const swiper = new Swiper('.page-edu--slider', {
      modules: [EffectFade],
      effect: 'fade',
      noSwiping: true,
      noSwipingClass: '.swiper-slide',
      allowTouchMove: false,
    });

    switchToggle.addEventListener('change', () => {
      if (switchToggle.checked) {
        swiper.slideTo(1);
      } else {
        swiper.slideTo(0);
      }
    });
  }
});
